import { Message } from 'element-ui';
/**
 * @description 格式化列表数据 -- 数据字典转换, 事件按钮控制
 * @param {*} data
 */
export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(e => {
        e.statusName = t(e.status, dictData, 'THORN_ATTACHMENT_STATUS_TYPE'); // 签章状态
        e.createWayName = t(e.createWay, dictData, 'TP_DOCUMENTS_WAY'); // 生成方式
        e.objTypeName = t(e.objType, dictData, 'OTP_ATTACHMENT_TYPE'); // 履约附件类型
    });
    return data;
};

const t = (key, dict, dicType) => {
    if (!key) return '';
    if (!dict[dicType]) {
        Message.warning(`未获取数据字典: ${dicType}`);
        return key;
    };
    return dict[dicType][key];
};

/**
 * @description 判断文件是否是文档类型
 * @param {String} type 文件类型
 */
export const getSuffixIsDocType = type => {
    return ['doc', 'docx', 'ppt', 'xlsx'].includes(type);
};
/**
 * @description 判断文件是否是图片类型
 * @param {String} type 文件类型
 */
export const getSuffixIsImageType = type => {
    return ['png', 'jpg', 'jpeg', 'gif'].includes(type);
};
/**
 * @description 下载附件
 * @param {Object} row 选中数据
 * @param {String} url 文件路径
 */
export const downloadFile = (row, url) => {
    if (row.type === 'pdf') {
        window.open(url);
    } else {
        window.location = url;
    }
};
